import type { TeamsApi } from "@/v2/api/metadata/teams";
import { buildFeedConfigTab } from "@/v2/kits/feed-config";
import { createTeamFeedConfigApi } from "./team-feed-config-api";

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(teamsApi: TeamsApi) {
  return buildFeedConfigTab(createTeamFeedConfigApi(teamsApi), {
    label: "Feed update configurations",
  });
}
